export default __webpack_public_path__ + "static/media/mainBanner.559095e9.png";